import React, {
  FC, useCallback, useEffect, useMemo, useState,
} from 'react';

import { AffectedQuestions } from '../../commons/AffectedQuestions';
import { QBackButton } from '../../commons/QBackButton';
import { QConfirmButton } from '../../commons/QConfirmButton';
import { QHeader } from '../../commons/QHeader';
import { Q7Form, Q7Response } from './form';
import { Row } from 'components/base/Row';

import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';
import { useBudget } from 'modules/budget/hooks/useBudget';
import { Address } from 'modules/budget/models/Address';
import { ILocation } from 'modules/budget/models/Location/types';

export const Q7: FC<Record<string, unknown>> = () => {
  const question = BudgetQuestionCodes.Q7;
  const { RespondQuestion } = useBudget();

  const [dismissService, setDismissService] = useState<boolean>(false);
  const [selectedAddress, setSelectedAddress] = useState<Address | null>(null);
  const [selectedLocation, setSelectedLocation] = useState<ILocation | null>(null);
  const [autorespond, setautorespond] = useState<boolean>(false);

  const canRespond = useMemo(
    () => {
      const isAddressFullfilled = selectedAddress?.isFullFilled() || false;
      return dismissService === true
        || (dismissService === false && isAddressFullfilled && selectedLocation);
    },
    [dismissService, selectedAddress, selectedLocation],
  );

  const response = useCallback(
    ({ gotoSummary }) => {
      if (!dismissService) {
        if (selectedAddress && selectedLocation) {
          RespondQuestion({
            gotoSummary,
            question,
            response: {
              address: selectedAddress,
              location: selectedLocation,
            },
          });
        }
      } else {
        RespondQuestion({
          gotoSummary,
          question,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dismissService, selectedAddress, selectedLocation],
  );

  useEffect(
    () => {
      if (autorespond && canRespond) {
        response({ gotoSummary: false });
      }
    },
    [autorespond, canRespond, response],
  );

  const onChange = useCallback(
    (responseData: Q7Response) => {
      setDismissService(Boolean(responseData.dismissService));
      setSelectedAddress(responseData.address);
      setSelectedLocation(responseData.location);
      setautorespond(responseData.autorespond);
    },
    [],
  );

  return (
    <React.Fragment>
      <QHeader question={question} />
      <Q7Form
        question={BudgetQuestionCodes.Q7}
        onChange={onChange}
      />
      <Row justifyContent="space-between">
        <QBackButton question={question} />
        <Row
          className="f-question-actions"
          justifyContent="flex-end"
        >
          <AffectedQuestions
            question={question}
            response={{
              address: selectedAddress,
              location: selectedLocation,
            }}
          />
          <QConfirmButton
            disabled={!canRespond}
            question={question}
            onClick={(payload) => response({ gotoSummary: payload?.gotoSummary })}
          />
        </Row>
      </Row>
    </React.Fragment>
  );
};
